import React from "react";
import { useSelector } from "react-redux";
import { decryptAEStoString } from "../../utils/utilities";
import { Navigate, useLocation } from "react-router-dom";

const PublicRoutes = ({ component }) => {
  let location = useLocation(),
    rawAccessToken = useSelector((state) => state.accessToken.value);
  rawAccessToken = rawAccessToken
    ? decryptAEStoString(rawAccessToken)
    : rawAccessToken;

  if (rawAccessToken)
    return <Navigate to="/dashboard" state={{ from: location }} replace />;

  return component;
};

export default PublicRoutes;
